import { render, staticRenderFns } from "./CadastroConfirmDialog.vue?vue&type=template&id=68cee8d3&scoped=true&lang=pug&"
import script from "./CadastroConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./CadastroConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./CadastroConfirmDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CadastroConfirmDialog.vue?vue&type=style&index=1&id=68cee8d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cee8d3",
  null
  
)

export default component.exports